import React from "react"
import styled from "styled-components"
import { Carousel as _Carousel } from "react-responsive-carousel"
import range from "lodash.range"

import { Flex, Box } from "components/box"
import Icon from "components/icon"

export const Container = styled(Box)`
  .carousel-root {
    outline: none;
  }

  .carousel.carousel-slider {
    display: inline-flex;
    position: relative;
    width: 100%;

    .slider-wrapper {
      overflow: hidden;
    }

    .slider {
      display: flex;
    }

    .control-dots {
      position: absolute;
      bottom: 0;
      text-align: center;
      width: 100%;

      .dot {
        transition: background 0.25s ease-in;
        background: ${props => props.theme.colors.silver};
        border-radius: 50%;
        width: ${props => props.theme.space[2]};
        height: ${props => props.theme.space[2]};
        margin: 0 ${props => props.theme.space[2]};
        cursor: pointer;
        display: inline-block;
      }

      .dot.selected {
        background: ${props => props.theme.colors.evergreen};
      }
    }

    .slide {
      display: flex;
      flex-direction: column;
      min-width: 100%;
      text-align: center;
    }
  }
`

export const CarouselArrow = styled(Icon)<{ side: "left" | "right" }>`
  display: none;
  cursor: pointer;

  bottom: -${props => props.theme.space[7]};
  ${props => props.side}: 35%;
  position: absolute;

  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    display: block;
    align-self: center;
    position: static;
  }
`

export const Carousel: React.FC<Partial<GetComponentProps<_Carousel>>> = props => (
  <Container>
    <_Carousel
      showArrows
      infiniteLoop
      showThumbs={false}
      showStatus={false}
      showIndicators
      renderArrowPrev={handleClick => (
        <CarouselArrow side="left" name="previous" onClick={handleClick} mr={[0, 0, 6, 6]} />
      )}
      renderArrowNext={handleClick => (
        <CarouselArrow side="right" name="next" onClick={handleClick} ml={[0, 0, 6, 6]} />
      )}
      {...props}
    />
  </Container>
)

const StarsContainer = styled(Flex)`
  svg {
    margin-right: ${props => props.theme.space[3]};

    path {
      fill: ${props => props.theme.colors.evergreen};
    }
  }
`

export const Stars: React.FC<{ rating: number }> = ({ rating }) => (
  <StarsContainer my={[4, null, 5]}>
    {range(0, rating).map(i => (
      <Icon name="star" key={i} />
    ))}
  </StarsContainer>
)
